import actions from './actions'
import mutations from './mutations'

const state = function () {
  return {
    notifications: {
      openAP: [],
      allUserNotifications: [],
      allTargetNotifications: [],
      targets: {},
      user: []
    }
  }
}

const getters = {
  userNotifications: state => {
    return state.notifications.allUserNotifications
  }
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/notifications/store/index.js